var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddcourseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.246,
    height: 18.635,
    viewBox: "0 0 17.246 18.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6336",
    "data-name": "Group 6336",
    transform: "translate(-5146.5 998.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M8.274,17.635H1.866A1.872,1.872,0,0,1,0,15.769V1.866A1.87,1.87,0,0,1,1.866,0H13.81V7.729a6,6,0,0,0-7.063,5.906c0,.12,0,.241.011.361H2.147a1.4,1.4,0,1,0,0,2.8h5.5a6.036,6.036,0,0,0,.628.839ZM2.613,2.426a.56.56,0,0,0-.56.56v8.77a.56.56,0,1,0,1.12,0V2.986A.56.56,0,0,0,2.613,2.426Z",
    transform: "translate(5147 -997.635)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(5155.746 -988)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 2,
    height: 8,
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 2,
    height: 8,
    transform: "translate(8 3) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcourseicon);
export default __webpack_public_path__ + "static/media/addcourseicon.33ada85af832bb0c65a41486ae5d6cb2.svg";
export { ForwardRef as ReactComponent };